import React from 'react'
import { Link, GatsbyLinkProps } from 'gatsby'
import styled from "styled-components"

interface OwnProps {
  href: GatsbyLinkProps<{}>['to'],
  text: string
}

export type ButtonProps = OwnProps

const StyledButton = styled(Link)`
  background: ${props => props.theme.colors.coral};
  border: 1px solid ${props => props.theme.colors.coral};
  border-radius: 32px;
  color: ${props => props.theme.colors.white};
  cursor: pointer;
  display: inlline-block;
  font-size: ${props => props.theme.fontSizes.text.button};
  letter-spacing: ${props => props.theme.letterSpacings.wide};
  padding: 16px 32px;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;

  &:focus,
  &:hover {
    background: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.coral};
  }
`;

const Button: React.FC<OwnProps> = ({
  href,
  text
}): React.ReactElement => {
  return (
    <StyledButton to={href}>
      {text}
    </StyledButton>
  )
}

export default Button
